module.exports = "/producer.jpg?f8b42f";